import './SidebarItem.scss';

interface SidebarItemProps {
    joinSignal: string;
    joinSignalLong: string;
    mouseEnter: (e: React.MouseEvent<HTMLTableRowElement>) => void;
    mouseLeave: (e: React.MouseEvent<HTMLTableRowElement>) => void;
    name: string;
    dataType: string;
    eventType: string;
    group?: string;
}

const SidebarItem = (props: SidebarItemProps) => {
    return (
        <div
            className='sidebar-item'
            onMouseEnter={props.mouseEnter}
            onMouseLeave={props.mouseLeave}
            data-join={props.joinSignal}
        >
            <div className='sidebar-item__description'>{props.name}</div>
            <div className='sidebar-item__join'>{props.joinSignalLong}</div>

            <div className='sidebar-item__bottom'>
                <div className='sidebar-item__data-type'>{props.dataType}</div>
                <div className='sidebar-item__event-type'>{props.eventType}</div>
            </div>
        </div>
    );
}

export default SidebarItem;
